export const GC_EXPIRE = 'tubonge-expire-time';
export const GC_EXPIRE_7DAYS = 'tubonge-expire-time-7days';
export const GC_AUTH_TOKEN = 'tubonge-auth-token';
export const GC_LIVE_TOKEN = 'tubonge-auth-live-token';
